import { render } from "./DataFlowDiagram.vue?vue&type=template&id=13876f6d"
import script from "./DataFlowDiagram.vue?vue&type=script&lang=js"
export * from "./DataFlowDiagram.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__